import { Box, LinearProgress, LinearProgressProps, Typography } from "@mui/material"
import { useFetchPathNormativitiesQuery } from "../../../api/rtk/base/slices/diagnosticsApiSlice"

type PathNormativitiesChartProps = {
    data: any
}

export const measureTypesNames: any = {
    Roughness: {
        name: 'Продольная ровность покрытия',
        shortName: 'Ровность'
    },
    Defects: {
        name: 'Состояние покрытия',
        shortName: 'Дефекты'
    },
    GaugeDepth: {
        name: 'Поперечная ровность (колейность)',
        shortName: 'Колейность'
    },
    Strength: {
        name: 'Прочность дорожной одежды',
        shortName: 'Прочность'
    },
    Cohesion: {
        name: 'Коэффициент сцепления',
        shortName: 'Сцепление'
    }
}


function LinearProgressWithLabel(props: LinearProgressProps & { value: number }) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ width: '100%', mr: 1 }}>
                <LinearProgress variant="determinate" {...props} />
            </Box>
            <Box sx={{ minWidth: 35 }}>
                <Typography variant="body2">{`${props.value}%`}</Typography>
            </Box>
        </Box>
    );
}

function getMeasureTypeTotalLength(data: any, measureType: any) {
    const totalLength = data[`${measureType}Total`]
    return totalLength ? totalLength.toFixed(3) : 0
}

export function PathNormativitiesChart({ data }: PathNormativitiesChartProps) {
    const { DiagnosticYear } = data ?? {}
    const measureTypes = Object.keys(measureTypesNames)
    const totalAdmissiblePercent = data[`totalAdmissiblePercent`]

    return (
        <div className="path-normativities-chart-div">
            <div className="chart-name">
                <span>Техническое состояние на {DiagnosticYear} г.</span>
            </div>
            <div className="chart-content">
                <div>
                    <p><strong>Обследовано:</strong></p>
                    {measureTypes.map((measureType: any) => <p>{getMeasureTypeTotalLength(data, measureType)} км</p>)}
                </div>
                <div>
                    <p><strong>Из них в нормативе:</strong></p>
                    {Object.values(measureTypesNames).map((measureTypesName: any) => {
                        return <p>{measureTypesName?.name}</p>
                    })}
                    <p><strong>По всем показателям:</strong></p>
                </div>
                <div className="admissible-values">
                    {measureTypes.map((measureType: any) => {
                        const admissiblePercent = data[`${measureType}AdmissiblePercent`]
                        return (
                            <>
                                {admissiblePercent !== null
                                    ?
                                    <div className="progress-bar-div">
                                        <Box sx={{ width: '100%' }}>
                                            <LinearProgressWithLabel classes={{root: "bar"}} value={admissiblePercent.toFixed(1)} />
                                        </Box>
                                    </div>
                                    :
                                    <p>Нет данных</p>
                                }
                            </>
                        )
                    })}
                    {totalAdmissiblePercent !== null
                        ?
                        <div className="progress-bar-div total-value">
                            <Box sx={{ width: '100%' }}>
                                <LinearProgressWithLabel className="bar" value={data[`TotalAdmissiblePercent`]?.toFixed(1)} />
                            </Box>
                        </div>
                        :
                        <p>Нет данных</p>
                    }
                </div>
            </div>
        </div>
    )
}
